import { dbApi } from "@/lib/api"
import type { ChatHistoryItem } from "@/types/chatHistory"

const ACTIVE_PREFIX = "ACTIVE#"

/** Parse DynamoDB `updated_at` (e.g. ACTIVE#2025-01-15T12:00:00.000Z) for sorting. */
export function chatUpdatedAtSortValue(updatedAt: string): number {
  const raw = updatedAt.startsWith(ACTIVE_PREFIX)
    ? updatedAt.slice(ACTIVE_PREFIX.length)
    : updatedAt
  const t = Date.parse(raw)
  return Number.isNaN(t) ? 0 : t
}

/** Newest chat first (sidebar list below the pending-new placeholder). */
export function sortChatsNewestFirst(chats: ChatHistoryItem[]): ChatHistoryItem[] {
  return [...chats].sort(
    (a, b) =>
      chatUpdatedAtSortValue(b.updated_at) - chatUpdatedAtSortValue(a.updated_at)
  )
}

export async function deleteChat(chatId: string): Promise<void> {
  await dbApi.delete(`api/chat/${chatId}`)
}
